import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
  } from "@mui/material";
  import { addDoc, collection, doc, updateDoc } from "firebase/firestore";
  import React, { useCallback, useEffect, useMemo, useState } from "react";
  import { useLocation, useNavigate } from "react-router-dom";
  import { toast } from "react-toastify";
  import "react-toastify/dist/ReactToastify.css";
  import { db } from "../../../api/firebase";
  import { nbfHR } from "../../../api/restApi";
  import {
    HRData,
    setHR,
  } from  "../../../store/reducer/hrSlice";
  import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
  import MaterialTable from "../Tables/MaterialTable";
  const HR = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const { HR } = useAppSelector(HRData);
    const dispatch = useAppDispatch();
    const collectionName = "HR";
    const level_3 = useAppSelector(state => state.accountLevels.level3);
  
    const nbfHRInfo = async () => {
      let HR = await nbfHR();
      dispatch(setHR(HR));
    };
  
    const handleCreateNewRow = async (values) => {
      try {
        // console.log('*********',values)
  
        if (!values || Object.keys(values).length === 0) {
          alert("Please enter valid data");
          return;
        }
        await addDoc(collection(db, collectionName), values);
        toast.success("Successfully add new item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        nbfHRInfo();
      } catch (error) {
        // console.log(error);
        console.log(error);
        toast.error("Failed to add new item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    };
  
    useEffect(() => {});
    const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
      // if (!Object.keys(validationErrors).length) {
  
      try {
        let id = row.getValue("id").toString();
        await updateDoc(doc(db, collectionName, id), values);
  
        toast.success("Successfully update  item !", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        nbfHRInfo();
      } catch (error) {
        // console.log(error);
        toast.error("Failed to  update  item!", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
  
      exitEditingMode(); //required to exit editing mode and close modal
      // }
    };
    const handleDeleteRow = useCallback(async (row) => {
      if (
        !window.confirm(`Are you sure you want to delete ${row.getValue("Name")}`)
      ) {
        return;
      }
    });
    const columns = useMemo(() => [
      {
        accessorKey: "id",
        header: "ID",
        enableColumnOrdering: false,
        enableEditing: false, //disable editing on this column
        enableSorting: false,
        size: 80,
      },
      {
        accessorKey: "name",
        header: "Name",
        size: 140,
      },
      {
        accessorKey: "designation",
        header: "Designation ",
        size: 140,
      },
      {
        accessorKey: "department",
        header: "Department",
        size: 140,
      },
      {
        accessorKey: "nic",
        header: "NIC",
        size: 140,
      },
      {
        accessorKey: "address",
        header: "Address",
        size: 140,
      },
      {
        accessorKey: "phone_number",
        header: "Phone Number",
        size: 140,
  
      },
      {
        accessorKey: "salary",
        header: "Salary ",
        size: 140,
      },
      {
        accessorKey: "advanced",
        header: "Advanced/ Loan ",
        size: 140,
      },
    ]);
    return (
      <>
        <Stack spacing={4} marginX={4} mt={1}>
          <MaterialTable
            setCreateModalOpen={setCreateModalOpen}
            tableData={HR}
            handleSaveRowEdits={handleSaveRowEdits}
            //   handleCancelRowEdits={handleCancelRowEdits}
            handleDeleteRow={handleDeleteRow}
            columns={columns}
            csvFileName="HR"
          ></MaterialTable>
        </Stack>
        <CreateNewAccountModal
          columns={columns}
          open={createModalOpen}
          onClose={() => setCreateModalOpen(false)}
          onSubmit={handleCreateNewRow}
        />
      </>
    );
  };
  
  //example of creating a mui dialog modal for creating new rows
  export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit }) => {
    const initialValues = {
      // Address: '',
      // City: '',
      // Name: '',
      // id: '',
      // Email: ''
    };
    const [values, setValues] = useState(initialValues);
  
    // useEffect(() => {
    //   setValues(initialValues);
    // }, []);
  
    const handleSubmit = async () => {
      onSubmit(values);
      onClose();
    };
  
    return (
      <Dialog open={open}>
        <DialogTitle textAlign="center">Create New HR</DialogTitle>
        <DialogContent>
          <form onSubmit={(e) => e.preventDefault()}>
            <Stack
              sx={{
                width: "100%",
                minWidth: { xs: "300px", sm: "360px", md: "400px" },
                gap: "1.5rem",
              }}
            >
              {columns.map((column) => {
                // Remove columns from new update
                if (column.accessorKey !== "id") {
                  return (
                    <TextField
                      key={column.accessorKey}
                      label={column.header}
                      name={column.accessorKey}
                      onChange={(e) =>
                        setValues({ ...values, [e.target.name]: e.target.value })
                      }
                    />
                  );
                }
              })}
            </Stack>
          </form>
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="secondary" onClick={handleSubmit} variant="contained">
            ADD NEW HR
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  export default HR;
  